import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkTableModule } from "@angular/cdk/table";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { RnaMutationUploadModule } from "../../domain/components/rna-mutation-upload/rna-mutation-upload.module";
import { SamplesPageComponent } from "./samples-page.component";

@NgModule({
  declarations: [SamplesPageComponent],
  imports: [
    CommonModule,
    TranslateModule,
    CdkTableModule,
    DragDropModule,
    FormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatSortModule,
    LucideAngularModule,
    RouterModule.forChild([{ path: "", component: SamplesPageComponent }]),
    RnaMutationUploadModule,
  ],
})
export class SamplesPageModule {}
